import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=08ec42e2&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "./summary.vue?vue&type=style&index=0&id=08ec42e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec42e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ec42e2')) {
      api.createRecord('08ec42e2', component.options)
    } else {
      api.reload('08ec42e2', component.options)
    }
    module.hot.accept("./summary.vue?vue&type=template&id=08ec42e2&scoped=true", function () {
      api.rerender('08ec42e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectSettlement/summary.vue"
export default component.exports